import { NgModule } from "@angular/core";
import { CellComponentOutletDirective } from "./cell-component-outlet.directive";

@NgModule({
  declarations: [ CellComponentOutletDirective ],
  exports: [ CellComponentOutletDirective ],
})
export class CellComponentOutletModule {}
